function Wave(props) {
   return(
      <svg xmlns="http://www.w3.org/2000/svg" width="374" height="61.19" viewBox="0 0 374 61.19">
         <path id="Wave_1" d="M11770.5,14029.157h-374v-53.565c2.369-.533,11.105-2.408,24.075-4.172a372.719,372.719,0,0,1,50.021-3.453,285.549,285.549,0,0,1,52.41,4.569,210.155,210.155,0,0,1,26.693,6.783,167.4,167.4,0,0,1,25.571,10.735,354.532,354.532,0,0,0,65.006,26.8c21.405,6.245,41.771,9.413,60.529,9.415h.025c26.779,0,50.22-6.415,69.668-19.067v21.952Z" transform="translate(-11396.5 -13967.967)" fill="#fff"/>
      </svg>
   )
}

export default Wave;